import { CONFIG, authHeaders } from '../utils/config';
const BASE_URL = CONFIG.BASE_URL || 'http://localhost:5000';

const handleError = async (res) => {
  if (!res.ok) {
    const msg = (await res.json().catch(() => ({}))).error || 'Erreur inconnue';
    throw new Error(msg);
  }
  return res;
};

export const VCardService = {
  /* -----  CRUD  ----- */
  async list() {
    const res = await fetch(`${BASE_URL}/vcard/`, { headers: authHeaders() });
    await handleError(res);
    return res.json();
  },

  async create(payload) {
    const res = await fetch(`${BASE_URL}/vcard/`, {
      method: 'POST',
      headers: authHeaders(true),
      body: JSON.stringify(payload),
    });
    await handleError(res);
    return res.json();
  },

  async update(uuid, updates) {
    const res = await fetch(`${BASE_URL}/vcard/${uuid}`, {
      method: 'PATCH',
      headers: authHeaders(true),
      body: JSON.stringify(updates),
    });
    await handleError(res);
    return res.json();
  },

  async remove(uuid) {
    const res = await fetch(`${BASE_URL}/vcard/${uuid}`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    await handleError(res);
  },

  async getPublic(uuid) {
    const res = await fetch(`${BASE_URL}/vcard/${uuid}/data`, {
	    headers: authHeaders(true),
    }); // pas d’auth requis
    await handleError(res);
    return res.json(); // { uuid: string; data: {...} }
  },

  /* -----  appel /vcard/<uuid> (public)  ----- */
  /* télécharger le fichier .vcf */
  async getVCardString(uuid) {
    const res = await fetch(`${BASE_URL}/vcard/${uuid}`);
    await handleError(res);
    return res.text();
  },
};
